module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_edito_m.c49744092fd9ea22cd4cfa902029b8c2.png";